import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const poDetailsSlice = createApi({
    reducerPath: "poDetails",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        poDetails: builder.query({
            query: (data) => ({ url: "/inventory/api/v1/purchaseorder/detail", params: data, method: "GET" }),
        }),
    }),
});

export const { usePoDetailsQuery } = poDetailsSlice;
